<app-switch>
  <input
    type="checkbox"
    id="switch-{{ id }}"
    [(ngModel)]="switchValue"
    (ngModelChange)="switch($event)"
    [disabled]="(!(scope | billingScope) && (!switchValue || !overridePermissionIfTrue)) || disabled"
  />
  <label for="switch-{{ id }}"></label>
</app-switch>
